module.exports = __webpack_public_path__ + "static/media/sport-logo.4f14a4c8.png";